module.exports = __webpack_public_path__ + "img/video_3.87d69160.jpg";